import Notification from '@components/Notification.vue';
import Message from '@components/Message.vue';
import { createApp } from 'vue';

export function notification(contents, delay,type,moreContent) {
    const container = document.createElement("div")
    let contentArr
    if(typeof(contents)=="string"){
        contentArr=[contents]
    }else if(contents instanceof Array){
        contentArr=contents
    }else{
        return
    }
     
    const notification = createApp(Notification, { contents: contentArr, delay: delay, type: type,moreContent:moreContent, handleRemove: () => { document.body.removeChild(container) } })
    notification.mount(container)
    document.body.appendChild(container)
}
export function message(content, confirm) {
    const container = document.createElement("div")
    const message = createApp(Message, { content: content, confirm: confirm, handleRemove: () => { document.body.removeChild(container) } })
    message.mount(container)
    document.body.appendChild(container)
}